import './discount-content.scss';

import { FaChevronLeft } from 'react-icons/fa';
import { useSelector } from 'react-redux';

import DeliveryDiscountItem from '@/resources/components/cart/shipment/address/components/delivery/shippingDiscountModal/DeliveryDiscountItem';
import Skeleton from '@/resources/components/global/Skeleton';
import { ApplicationState } from '@/store';
import { IDeliveryDiscountData } from '@/store/ducks/deliveryDiscount/types';

export function DiscountContent({ onShow, onClose }: { onShow: boolean; onClose?: () => void }) {
  const shippingDiscount = useSelector<ApplicationState, IDeliveryDiscountData[]>(
    (state) => state.deliveryDiscount.data,
  );

  const isLoading = useSelector<ApplicationState, boolean>(
    (state) => state.deliveryDiscount.loading,
  );
  const getShippingDiscounts = () => {
    return shippingDiscount?.filter((discount) => discount.type_discount === 'free');
  };

  const shippingRules = getShippingDiscounts();

  return (
    <div className={`d-flex flex-column gap-3 ${onShow ? 'content-show' : 'content-hide'}`}>
      <div className="d-flex flex-column align-items-start justify-content-center px-1">
        <h5 className="text-center">
          <FaChevronLeft onClick={() => onClose?.()} /> Descontos
        </h5>
        <p className="text-muted text-center pl-2">
          Confira nossas ofertas e promoções exclusivas!
        </p>
      </div>
      <div className="d-flex flex-column gap-2 content-body p-2">
        {!shippingRules.length && !isLoading && (
          <div className="text-center">Nenhum desconto disponível.</div>
        )}

        {!shippingRules.length && isLoading && (
          <>
            {Array.from({ length: 3 }, (_, i) => (
              <Skeleton key={i} style={{ width: '100%', height: '100px' }} />
            ))}
          </>
        )}

        {shippingRules && (
          <>
            {shippingRules.map((discount) => (
              <DeliveryDiscountItem key={discount.id} discount={discount} />
            ))}
          </>
        )}
      </div>
    </div>
  );
}
